import TeamsBlock from './TeamsBlock';
import { TeamsBlockProps, TeamsBlockValueProps } from './types';

export type { TeamsBlockProps, TeamsBlockValueProps };
export default TeamsBlock;
